var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-page mission"},[_c('basic-page',{attrs:{"fulldata":_vm.fulldata,"pagedata":this.pageData,"bannerimg":this.bannerimg}},[_c('h1',[_vm._v("Downloading sitemap.xml ...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }